import { lazyLoad } from 'utils/loadable';

export const CentreFormPage = lazyLoad(
  () => import('./index'),
  module => module.CentreFormPage,
);
